import {
  animate,
  style,
  transition,
  trigger
} from "@angular/animations";
import { HttpHeaders } from "@angular/common/http";
import {
  Component,
  ElementRef,
  HostListener,
  OnInit,
  ViewChild
} from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { HttpClientService } from "../../Services/http-client.service";
import { SessionService } from "../../Services/session.service";
import { AppSettings } from "../../app-settings";
import Editor from 'egmat-ckeditor5';
import { EMOJI_REGEX } from "app/models/ckeditor-config";
declare var MathJax: any;
@Component({
  selector: "app-forums-expert",
  templateUrl: "./forums-expert.component.html",
  styleUrls: [
    "../forums-user/forums-user.component.scss",
    "./forums-expert.component.scss",
  ],
  animations: [
    trigger("scrollUpInOut", [
      transition(":enter", [
        style({ opacity: 0 }),
        animate("0.5s", style({ opacity: 1 })),
      ]),
      transition(":leave", [
        style({ opacity: 1 }),
        animate("0.5s", style({ opacity: 0 })),
      ]),
    ]),
    trigger("confirmationPopUpInOut", [
      transition(":enter", [
        style({ opacity: 0 }),
        animate("0.3s", style({ opacity: 1 })),
      ]),
      transition(":leave", [
        style({ opacity: 1 }),
        animate("0.3s", style({ opacity: 0 })),
      ]),
    ]),
  ],
})
export class ForumsExpertComponent implements OnInit {
  @HostListener("window:scroll", ["$event"])
  onWindowScroll(event) {
    if (event.currentTarget.pageYOffset > 3818) {
      this.backToTopImg = true;
    } else {
      this.backToTopImg = false;
    }
  }
  constructor(
    private sessionService: SessionService,
    private route: ActivatedRoute,
    private httpClientService: HttpClientService,
  ) {}

  forumMode: string = "ACTIVITY";
  isReviewMode: number = 0;

  krishnaImage = AppSettings.cdnUrl + "assets/images/KrishnaProfile1.png";
  notLikedImage = AppSettings.cdnUrl + "assets/images/notliked.png";
  notDislikedImage = AppSettings.cdnUrl + "assets/images/notdisliked.png";
  likedImage = AppSettings.cdnUrl + "assets/images/liked.png";
  dislikedImage = AppSettings.cdnUrl + "assets/images/disliked.png";
  downLessImage = AppSettings.cdnUrl + "assets/images/down_arrow_more.png";
  upMoreImage = AppSettings.cdnUrl + "assets/images/up_arrow_more_less.png";
  scrollTopImage = AppSettings.cdnUrl + "assets/images/up-arrow-forums.png";
  loadingCircleURL = AppSettings.loadingCircleImageURL;
  randomColors = [
    "#2a098d",
    "#3d9d01",
    "#c47439",
    "#23c6e4",
    "#1156de",
    "#03254e",
    "#5601a7",
    "#5e1317",
    "#27AE60",
    "#A569BD",
    "#df715f",
    "#e084cd",
    "#093c3e",
    "#616252",
    "#0f5d7e",
    "#23776e",
    "#7b789f",
    "#aa85fc",
    "#ac2001",
    "#154360",
    "#B7950B",
  ];

  originalScrollPostition: number;
  newQueryPost: boolean = false;
  ckeditorNewQueryContent: string = "";
  postQueryHeading: string = "";
  singleForum: any = {};
  likeDislikeArray: any = [];
  totalLikeDislike: any = {};
  AllForums: any = [];
  activityId: number;
  AllForumsTemplateData: any = [];
  threadExpandedArray: any = [];
  corelationID: string;
  ReviewMode: boolean = false;
  discussionIDVsCorelationID: any = [];
  corelationIDList: any = {};
  scrollOnce: boolean = true;
  emptyMainPost: boolean = false;
  emptyPostSubject: boolean = false;
  characterExceedSubjectError: boolean = false;
  characterExceedError: boolean = false;
  showForumsOnLoad: boolean = false;
  scrolltoSlideForums = false;
  ckEditorWordsLimit: number = 3000;
  ckEditorHeadingLimit: number = 300;
  insideArray: any = [];
  levelIndentValue: number = 0;
  activityForumsDisplayHide: boolean = false;
  addToNotesSingle: boolean = true;
  postnewQuerySingle = true;
  forumLoadedFlag: boolean = false;
  loadForumsData: boolean = true;
  backToTopImg: boolean = false;
  deletePostConfirmation: boolean = false;
  isDeleteButtonActive: boolean = false;
  accessedForumsFlag: boolean = false;
  displayImportantPostsPrompt: boolean = false;
  deletePostId: number;
  deleteConfImg: string =
    AppSettings.cdnUrl + "assets/images/delete_conf_experts.png";
  editor = Editor as any;
  defaultView: string = "others";
  @ViewChild("_displayForumsThreadAfter", { static: false })
  displayForumsThreadAfter: ElementRef;
  @ViewChild("_displayForumsThreadStart", { static: true })
  displayForumsThreadStart: ElementRef;
  ngOnInit() {
    this.getForumsMode();
    this.getThreadExpansion();

    this.sessionService.updateForumsData$.subscribe((item) => {
      if (item != 0) {
        //console.log("slidechange" + item);
        if (this.forumMode == "SLIDE") {
          this.AllForumsTemplateData = [];
          this.showForumsOnLoad = false;
        }
      }
    });

    this.sessionService.updateDashboard$.subscribe((item) => {
      if (item != 0) {
        //console.log("forums loaded" + item);
        this.showForumsOnLoad = true;
        this.scrolltoSlideForums = true;
        this.getForumsData();
      }
    });

    this.sessionService.updateActivityForumsDisplayState$.subscribe((item) => {
      if (item != 0) {
        this.activityForumsDisplayHide = false;
        this.showForumsOnLoad = true;
        this.scrolltoSlideForums = true;
        this.getForumsDataOnReviewButtonClick();
      }
    });
    this.sessionService.updateAddedToNotesFlag$.subscribe((item) => {
      if (item != 0) {
        this.changeAddedToNoteFlag(item);
      }
    });
  }
  ngOnDestroy() {
    this.sessionService.updateActivityForumsDisplayState(0);
  }
  getForumsMode() {
    this.route.params.subscribe((params) => {
      if (params["activity"]) {
        this.activityId = params["activity"];
        /*let headers = new HttpHeaders();
                  this.httpClientService.get(AppSettings.restApiUrl +
                  '/api/activity/'+this.activityId+'/forum/0/', headers)
                  .subscribe(
                  (data) => {
                    this.forumMode = data.forumType;
                    if(this.forumMode == "ACTIVITY")
                    {
                       this.getForumsData();
                       this.showForumsOnLoad = true;
                       //this.activityForumsDisplayHide = true;
                       //this.scrolltoSlideForums = true;
                    }
                    else
                    {
                       this.showForumsOnLoad = false;
                       this.activityForumsDisplayHide = false;
                    }
                  });*/
        this.displayForumsThreadStart.nativeElement.style.display = "none";
        this.showForumsOnLoad = false;
        this.activityForumsDisplayHide = false;
        this.ReviewMode = false;
        this.isReviewMode = 0;
        this.forumLoadedFlag = false;
        this.loadForumsData = true;
        //this.showForumsOnLoad = true;
      } else if (params["corelationid"]) {
        this.corelationID = params["corelationid"];
        this.getReviewModeForums(this.corelationID);
        this.ReviewMode = true;
        this.isReviewMode = 1;
        this.showForumsOnLoad = true;
        this.activityForumsDisplayHide = false;
        // this.forumLoadedFlag = true;
      }
    });
  }
  getReviewModeForums(corelationId) {
    let headers = new HttpHeaders();
    this.httpClientService
      .get(
        AppSettings.restApiUrl + "/api/link/forum/" + corelationId + "/",
        headers
      )
      .subscribe((data) => {
        this.activityId = data.forumObjectId;
        this.getForumsData();
      });
  }

  getForumsDataOnReviewButtonClick() {
    if (this.scrolltoSlideForums) {
      this.scrollToFormus();
      this.scrolltoSlideForums = false;
    }

    if (this.loadForumsData) {
      this.getForumsData();
      this.loadForumsData = false;
    }
  }

  getForumsData() {
    let headers = new HttpHeaders();
    this.httpClientService
      .get(
        AppSettings.restApiUrl +
          "/api/ACTIVITY/" +
          this.activityId +
          "/forum/" +
          this.isReviewMode +
          "/ASC/" +
          this.accessedForumsFlag,
        headers
      )
      .subscribe((data) => {
        if (data.showImportantPosts != undefined)
          this.displayImportantPostsPrompt = data.showImportantPosts;

        this.forumLoadedFlag = true;
        // this.defaultView=data.defaultView;
        // this.defaultView = viewTab;
        this.AllForums = [];
        var forumsData = data;
        if (forumsData.forumPostsVO != null) {
          var allThreads = forumsData.forumPostsVO;
          var totalPosts = allThreads.length;
          for (var i = 0; i < totalPosts; i++) {
            var forum = this.addSinglePost(i, allThreads, 0);

            if (allThreads[i].forumPostsVO != null) {
              this.insideArray = [];
              //for(var j=0;j<allThreads[i].forumPostsVO.length;j++)
              //{
              //forum.forumPostsVO.push(this.addSinglePost(j,allThreads[i].forumPostsVO));
              this.singleArray(allThreads[i].forumPostsVO, 0);
              forum.forumPostsVO = this.insideArray;
              //}
            } else {
              allThreads[i].forumPostsVO = [];
            }
            this.AllForums.push(forum);
          }

          this.forumLoadedFlag = true;
          this.AllForumsTemplateData = this.AllForums;
          if (this.ReviewMode) {
            this.setThreadExpansion(
              this.getIndexofThread(this.getdiscussionID(this.corelationID)),
              true
            );
          }
        } else {
          this.forumLoadedFlag = true;
          this.AllForumsTemplateData = [];
        }
        /*if(this.forumMode == "SLIDE" && this.scrolltoSlideForums)
        {
            this.scrollToFormus();
            this.scrolltoSlideForums = false;
        }*/
        this.filterCurrentTabData();
        this.updateResult();
      });
  }
  filterCurrentTabData() {
    let showImportantQueries = this.defaultView != "others";
    if (showImportantQueries) {
      this.AllForumsTemplateData = this.AllForums.filter(
        (item) => item["important"]
      );
      this.defaultView = "important";
      //console.log(this.AllForumsTemplateData, this.AllForums);
    } else {
      this.AllForumsTemplateData = this.AllForums;
      //console.log(this.AllForumsTemplateData, this.AllForums);
      this.defaultView = "others";
    }
    this.updateResult();
  }

  filterDiscussions(event: any) {
    //console.log(event.target.checked);
    let showImportantQueries = event.target.checked;
    if (showImportantQueries) {
      this.AllForumsTemplateData = this.AllForums.filter(
        (item) => item["important"]
      );
      this.defaultView = "important";
      //console.log(this.AllForumsTemplateData, this.AllForums);
    } else {
      this.AllForumsTemplateData = this.AllForums;
      //console.log(this.AllForumsTemplateData, this.AllForums);
      this.defaultView = "others";
    }
  }
  singleArray(arr: any, j) {
    if (arr == null) {
      return;
    }
    for (var i = 0; i < arr.length; i++) {
      this.insideArray.push(this.addSinglePost(i, arr, j));
      this.singleArray(arr[i].forumPostsVO, j + 1);
    }
  }
  scrollToCurrentDiscussion() {
    if (this.ReviewMode) {
      //window.scrollTo(0, document.getElementById(this.corelationID).offsetTop);
      var forumsLocation = document.getElementById(this.corelationID).offsetTop;
      var body = document.body,
        html = document.documentElement;

      var height = Math.max(
        body.scrollHeight,
        body.offsetHeight,
        html.clientHeight,
        html.scrollHeight,
        html.offsetHeight
      );
      var scrollheight = height - forumsLocation;
      /*var timerID = setInterval(function()
          {
              window.scrollBy(0, 15);
              if(window.innerHeight + window.pageYOffset >= height || window.pageYOffset >= forumsLocation || (window.innerHeight + window.scrollY) >= document.documentElement.scrollHeight-5)
                  clearInterval(timerID);
          }, 5);*/
      window.scrollTo(0, forumsLocation);
      this.storeScrollPostion();
    }
    this.scrollOnce = false;
  }
  getThreadExpansion() {
    for (var i = 0; i < this.AllForums.length; i++) {
      this.threadExpandedArray.push(false);
    }
  }
  setThreadExpansion(index, state) {
    this.threadExpandedArray[index] = state;
  }
  addSinglePost(i, allThreads, level) {
    this.singleForum = {};
    this.singleForum.id = allThreads[i].id;
    this.singleForum.forumPostSubject = allThreads[i].forumPostSubject;
    this.singleForum.postedBy = allThreads[i].postedBy;
    this.singleForum.forumPostText = allThreads[i].forumPostText;
    if (
      allThreads[i].expertReplyText != null &&
      allThreads[i].expertReplyText != ""
    ) {
      this.singleForum.expertReplyText = allThreads[i].expertReplyText
    } else {
      this.singleForum.expertReplyText = allThreads[i].expertReplyText;
    }
    this.singleForum.expertReplySubject = allThreads[i].expertReplySubject;
    this.singleForum.expertName = allThreads[i].expertName;
    this.singleForum.expertReplyPostId = allThreads[i].expertReplyPostId;
    this.singleForum.correlationId = allThreads[i].correlationId;
    this.singleForum.expertReplyTotalLikes =
      allThreads[i].expertReplyTotalLikes;
    this.singleForum.expertRepyTotalUnlikes =
      allThreads[i].expertRepyTotalUnlikes;
    this.singleForum.isLikedByUser = allThreads[i].isLikedByUser;
    this.singleForum.isUnlikedByUser = allThreads[i].isUnlikedByUser;
    this.singleForum.creationTime = allThreads[i].creationTime;
    this.singleForum.expertResponseTime = allThreads[i].expertResponseTime;
    this.singleForum.forumId = allThreads[i].forumId;
    this.singleForum.parentId = allThreads[i].parentId;
    this.singleForum.discussionId = allThreads[i].discussionId;
    this.singleForum.forumPostType = allThreads[i].forumPostType;
    this.singleForum.forumPostsVO = [];
    this.singleForum.expanded = false;
    this.singleForum.letterColor = this.randomColor(this.singleForum.postedBy);
    this.singleForum.followUpCKEditor = false;
    this.singleForum.followUpCKEditorEmptyPost = false;
    this.singleForum.followUpCKEditorCharacterError = false;
    this.singleForum.followUpCKEditorquery = "";
    this.singleForum.addedToNotes = allThreads[i].addedToNotes;
    this.singleForum.expanded = false;
    this.singleForum.ckEditorExpert = false;
    this.singleForum.postOneTime = true;
    this.singleForum.editForumPostExpertFlag = false;
    this.singleForum.expertEditCKEditorContent = allThreads[i].expertReplyText;
    this.singleForum.emptyEditExpertPost = false;
    this.singleForum.characterEditExpertExceedError = false;
    this.singleForum.editSingleExpertPost = true;
    this.singleForum.studentEditCKEditorContent = allThreads[i].forumPostText;
    this.singleForum.editForumPostStudentFlag = false;
    this.singleForum.emptyEditStudentPost = false;
    this.singleForum.characterEditStudentExceedError = false;
    this.singleForum.editSingleStudentPost = true;
    this.singleForum.editStudentSubject = allThreads[i].forumPostSubject;
    this.singleForum.editCharacterExceedSubjectError = false;
    this.singleForum.editEmptyPostSubject = false;
    this.singleForum.deletesingleNote = false;
    this.singleForum.important = allThreads[i].important;
    if (allThreads[i].expertDisplaypicture == null) {
      this.singleForum.expertDisplaypicture =
        "https://cdn.e-gmat.com/wp-content/themes/twentythirteen/images/egmat3_images/AbhinavPuri.png";
    } else {
      this.singleForum.expertDisplaypicture =
        allThreads[i].expertDisplaypicture;
    }
    this.singleForum.ckEditorExpertPostText = "";
    this.singleForum.level = level;
    if (allThreads[i].expertReplyPostId == null) {
      this.singleForum.expertResponded = false;
    } else {
      this.singleForum.expertResponded = true;
    }
    if (this.singleForum.expertResponded) {
      this.totalLikeDislike = {};
      this.totalLikeDislike.postID = allThreads[i].expertReplyPostId;
      this.totalLikeDislike.isLikedByUser = allThreads[i].isLikedByUser;
      this.totalLikeDislike.isUnlikedByUser = allThreads[i].isUnlikedByUser;
      this.totalLikeDislike.expertReplyTotalLikes =
        allThreads[i].expertReplyTotalLikes;
      this.totalLikeDislike.expertRepyTotalUnlikes =
        allThreads[i].expertRepyTotalUnlikes;
      this.totalLikeDislike.likeImage = this.likeImage(
        allThreads[i].isLikedByUser
      );
      this.totalLikeDislike.disLikeImage = this.disLikeImage(
        allThreads[i].isUnlikedByUser
      );
      this.likeDislikeArray.push(this.totalLikeDislike);
    }
    this.corelationIDList = {};
    this.corelationIDList.discussionID = allThreads[i].discussionId;
    this.corelationIDList.corelationID = allThreads[i].correlationId;
    this.discussionIDVsCorelationID.push(this.corelationIDList);

    return this.singleForum;
  }

  getReactions(postId): any {
    var arrByID = this.likeDislikeArray.filter(function (obj) {
      return obj.postID == postId;
    });
    return arrByID[0];
  }
  getdiscussionID(corelationID) {
    var discussionID = this.discussionIDVsCorelationID.filter(function (obj) {
      return obj.corelationID == corelationID;
    });
    return discussionID[0].discussionID;
  }
  randomColor(userString: string): any {
    var firstLetterCode = userString.trim().toUpperCase().charCodeAt(0);
    var index;
    if (firstLetterCode >= 65 && firstLetterCode <= 74) {
      index = firstLetterCode % 10;
    } else if (firstLetterCode >= 75 && firstLetterCode <= 84) {
      index = (firstLetterCode % 10) + 10;
    } else if (firstLetterCode >= 85 && firstLetterCode <= 90) {
      index = firstLetterCode % 10;
    } else {
      index = 1;
    }
    return this.randomColors[index];
  }
  likeChange(postID) {
    var index = this.getIndex(postID);
    var liked = this.likeDislikeArray[index].isLikedByUser;
    var disliked = this.likeDislikeArray[index].isUnlikedByUser;
    var likedNumbers = this.likeDislikeArray[index].expertReplyTotalLikes;
    var disLikedNumbers = this.likeDislikeArray[index].expertRepyTotalUnlikes;
    if (liked) {
      this.likeDislikeArray[index].expertReplyTotalLikes--;
      this.likeDislikeArray[index].isLikedByUser = false;
      this.deleteReaction(postID);
    } else if (disliked) {
      this.likeDislikeArray[index].expertReplyTotalLikes++;
      this.likeDislikeArray[index].isLikedByUser = true;
      this.likeDislikeArray[index].isUnlikedByUser = false;
      this.likeDislikeArray[index].expertRepyTotalUnlikes--;
      this.likeDislikeArray[index].disLikeImage = this.disLikeImage(
        this.likeDislikeArray[index].isUnlikedByUser
      );
      this.postReaction(postID, "LIKE");
    } else if (!liked) {
      this.likeDislikeArray[index].expertReplyTotalLikes++;
      this.likeDislikeArray[index].isLikedByUser = true;
      this.postReaction(postID, "LIKE");
    }
    this.likeDislikeArray[index].likeImage = this.likeImage(
      this.likeDislikeArray[index].isLikedByUser
    );
  }
  dislikeChange(postID) {
    var index = this.getIndex(postID);
    var liked = this.likeDislikeArray[index].isLikedByUser;
    var disliked = this.likeDislikeArray[index].isUnlikedByUser;
    var likedNumbers = this.likeDislikeArray[index].expertReplyTotalLikes;
    var disLikedNumbers = this.likeDislikeArray[index].expertRepyTotalUnlikes;
    if (liked) {
      this.likeDislikeArray[index].expertReplyTotalLikes--;
      this.likeDislikeArray[index].isLikedByUser = false;
      this.likeDislikeArray[index].isUnlikedByUser = true;
      this.likeDislikeArray[index].expertRepyTotalUnlikes++;
      this.likeDislikeArray[index].likeImage = this.likeImage(
        this.likeDislikeArray[index].isLikedByUser
      );
      this.postReaction(postID, "UNLIKE");
    } else if (!disliked) {
      this.likeDislikeArray[index].isUnlikedByUser = true;
      this.likeDislikeArray[index].expertRepyTotalUnlikes++;
      this.postReaction(postID, "UNLIKE");
    } else if (disliked) {
      this.likeDislikeArray[index].isUnlikedByUser = false;
      this.likeDislikeArray[index].expertRepyTotalUnlikes--;
      this.deleteReaction(postID);
    }
    this.likeDislikeArray[index].disLikeImage = this.disLikeImage(
      this.likeDislikeArray[index].isUnlikedByUser
    );
  }
  postReaction(postID, reaction) {
    let headers = new HttpHeaders();
    this.httpClientService
      .post(
        AppSettings.restApiUrl +
          "/api/forum/post/" +
          postID +
          "/reaction/" +
          reaction,
        null,
        headers
      )
      .subscribe((data) => {});
  }
  deleteReaction(postID) {
    let headers = new HttpHeaders();
    this.httpClientService
      .put(
        AppSettings.restApiUrl + "/api/forum/post/" + postID + "/reaction/undo",
        null,
        headers
      )
      .subscribe((data) => {});
  }
  getIndex(postID): number {
    var index = this.likeDislikeArray.findIndex(function (obj) {
      return obj.postID == postID;
    });
    return index;
  }
  getIndexofThread(discussionId): number {
    var index = this.AllForums.findIndex(function (obj) {
      return obj.discussionId == discussionId;
    });
    return index;
  }
  likeImage(image: boolean) {
    if (image) {
      return this.likedImage;
    }
    return this.notLikedImage;
  }
  disLikeImage(image: boolean) {
    if (image) {
      return this.dislikedImage;
    }
    return this.notDislikedImage;
  }
  storeScrollPostion() {
    this.originalScrollPostition = window.scrollY;
  }
  scrollToOriginalPostion() {
    window.scrollTo(0, this.originalScrollPostition);
  }
  addToNotes(index, postId) {
    if (!this.AllForums[index].addedToNotes && this.addToNotesSingle) {
      this.addToNotesSingle = false;
      var forumNoteObject = { forumPostId: postId, objectId: this.activityId };
      let headers = new HttpHeaders();
      this.httpClientService
        .post(
          AppSettings.restApiUrl + "/api/notes/forumPost/create/",
          forumNoteObject,
          headers
        )
        .subscribe((data) => {
          this.AllForums[index].addedToNotes = true;
          this.addToNotesSingle = true;
          this.sessionService.updateActivityNotes(1);
        });
    }
  }
  changeAddedToNoteFlag(forumId) {
    var index = this.getForumIndex(forumId);
    this.AllForums[index].addedToNotes = false;
  }
  getForumIndex(forumId) {
    var index = this.AllForums.findIndex(function (obj) {
      return obj.id == forumId;
    });
    return index;
  }
  postNewQuery() {
    if (!this.postnewQuerySingle) {
      return;
    }
    this.postQueryHeading = this.stripHTMLTags(this.postQueryHeading);
    var editorTextOnly = this.stripHTMLTags(this.ckeditorNewQueryContent);
    if (editorTextOnly.trim() == "") {
      this.emptyMainPost = true;
      this.characterExceedError = false;
      this.emptyPostSubject = false;
      this.characterExceedSubjectError = false;
      return;
    } else if (this.postQueryHeading.trim() == "") {
      this.emptyPostSubject = true;
      this.emptyMainPost = false;
      this.characterExceedError = false;
      this.characterExceedSubjectError = false;
      return;
    } else if (
      this.postQueryHeading.trim().length > this.ckEditorHeadingLimit
    ) {
      this.characterExceedSubjectError = true;
      this.characterExceedError = false;
      this.emptyPostSubject = false;
      this.emptyMainPost = false;
      return;
    } else if (editorTextOnly.trim().length > this.ckEditorWordsLimit) {
      this.characterExceedError = true;
      this.emptyPostSubject = false;
      this.emptyMainPost = false;
      this.characterExceedSubjectError = false;
      return;
    }
    this.postnewQuerySingle = false;
    var newPostQuery = {
      postSubject: this.postQueryHeading,
      postText: this.ckeditorNewQueryContent,
    };
    this.storeScrollPostion();
    let headers = new HttpHeaders();
    this.httpClientService
      .post(
        AppSettings.restApiUrl +
          "/api/" +
          this.activityId +
          "/forum/discussion/" +
          this.isReviewMode +
          "/",
        newPostQuery,
        headers
      )
      .subscribe((data) => {
        this.postQueryHeading = "";
        this.ckeditorNewQueryContent = "";
        this.newQueryPost = false;
        this.emptyMainPost = false;
        this.emptyPostSubject = false;
        this.characterExceedError = false;
        this.postnewQuerySingle = true;
        this.getForumsData();
        this.scrollToOriginalPostion();
      });
  }
  stripHTMLTags(value): string {
    if (value == null) return value;
    var regex = /(&nbsp;|<([^>]+)>)/gi;
    return value.replace(regex, "");
  }
  postFollowUpQueryOnFollowUpQuery(parentId, followUpCKEditorquery, i, j) {
    if (!this.AllForumsTemplateData[i].forumPostsVO[j].postOneTime) {
      return;
    }
    followUpCKEditorquery = (followUpCKEditorquery || '').replace(EMOJI_REGEX,'');
    var editorTextOnly = this.stripHTMLTags(followUpCKEditorquery);
    if (editorTextOnly.trim() == "") {
      this.AllForumsTemplateData[i].forumPostsVO[j].followUpCKEditorEmptyPost =
        true;
      this.AllForumsTemplateData[i].forumPostsVO[
        j
      ].followUpCKEditorCharacterError = false;
      return;
    } else if (editorTextOnly.trim().length > this.ckEditorWordsLimit) {
      this.AllForumsTemplateData[i].forumPostsVO[
        j
      ].followUpCKEditorCharacterError = true;
      this.AllForumsTemplateData[i].forumPostsVO[j].followUpCKEditorEmptyPost =
        false;
      return;
    }
    this.storeScrollPostion();
    this.AllForumsTemplateData[i].forumPostsVO[j].postOneTime = false;
    this.postFollowUpQuery(parentId, followUpCKEditorquery, []);
  }
  postFollowUpQueryOnMainQuery(parentId, followUpCKEditorquery, index) {
    if (!this.AllForumsTemplateData[index].postOneTime) {
      return;
    }
    followUpCKEditorquery = (followUpCKEditorquery || '').replace(EMOJI_REGEX,'');
    var editorTextOnly = this.stripHTMLTags(followUpCKEditorquery);
    if (editorTextOnly.trim() == "") {
      this.AllForumsTemplateData[index].followUpCKEditorEmptyPost = true;
      this.AllForumsTemplateData[index].followUpCKEditorCharacterError = false;
      return;
    } else if (editorTextOnly.trim().length > this.ckEditorWordsLimit) {
      this.AllForumsTemplateData[index].followUpCKEditorCharacterError = true;
      this.AllForumsTemplateData[index].followUpCKEditorEmptyPost = false;
      return;
    }
    this.storeScrollPostion();
    this.AllForumsTemplateData[index].postOneTime = false;
    var answerTags = [];
    let checkboxes = <HTMLInputElement>(
      document.getElementById("tag_" + parentId)
    );
    if (checkboxes.checked) {
      answerTags.push(parseInt(checkboxes.value));
    }
    //console.log(answerTags);
    this.postFollowUpQuery(parentId, followUpCKEditorquery, answerTags);
  }
  postFollowUpQuery(parentId, followUpCKEditorquery, tags) {
    var newPostQuery = {
      postSubject: "",
      postText: followUpCKEditorquery,
      tagIdSet: tags,
    };
    let headers = new HttpHeaders();
    this.httpClientService
      .post(
        AppSettings.restApiUrl + "/api/forum/parent/" + parentId + "/",
        newPostQuery,
        headers
      )
      .subscribe((data) => {
        //this.AllForums = [];
        //this.AllForumsTemplateData[index].followUpCKEditor = false;
        this.getForumsData();
        this.scrollToOriginalPostion();
        this.updateResult();
      });
  }
  ngAfterViewChecked() {
    if (this.ReviewMode && this.scrollOnce) {
      if (document.getElementById(this.corelationID) != null) {
        this.scrollToCurrentDiscussion();
        this.originalScrollPostition =
          document.getElementById(this.getdiscussionID(this.corelationID))
            .offsetTop - 10;
      }
    }
  }
  scrollToFormus() {
    this.displayForumsThreadStart.nativeElement.style.display = "block";
    var forumsLocation = document.getElementById(
      "formus_scroll_point"
    ).offsetTop;
    var body = document.body,
      html = document.documentElement;

    var height = Math.max(
      body.scrollHeight,
      body.offsetHeight,
      html.clientHeight,
      html.scrollHeight,
      html.offsetHeight
    );
    var scrollheight = forumsLocation;
    var timerID = setInterval(function () {
      window.scrollBy(0, 20);

      if (
        window.pageYOffset >= scrollheight ||
        window.pageYOffset >= forumsLocation ||
        window.innerHeight + window.scrollY >=
          document.documentElement.scrollHeight - 5
      )
        clearInterval(timerID);
    }, 5);
  }

  showActivityForumsd() {
    this.displayForumsThreadStart.nativeElement.style.display = "block";
    this.displayForumsThreadAfter.nativeElement.style.display = "block";
    var forumsLocation = document.getElementById(
      "formus_scroll_point"
    ).offsetTop;
    var body = document.body,
      html = document.documentElement;

    var height = Math.max(
      body.scrollHeight,
      body.offsetHeight,
      html.clientHeight,
      html.scrollHeight,
      html.offsetHeight
    );
    var scrollheight = height - forumsLocation;
    //console.log(this.activityForumsDisplayHide);
    var timerID = setInterval(function () {
      window.scrollBy(0, 15);

      if (
        window.pageYOffset >= scrollheight ||
        window.pageYOffset >= forumsLocation
      )
        clearInterval(timerID);
    }, 5);
  }
  editMainExpertReplyPost(postId, followUpCKEditorquery, i) {
    if (!this.AllForumsTemplateData[i].editSingleExpertPost) {
      return;
    }
    followUpCKEditorquery = (followUpCKEditorquery || "").replace(EMOJI_REGEX,'');
    var editorTextOnly = this.stripHTMLTags(followUpCKEditorquery);
    if (editorTextOnly.trim() == "") {
      this.AllForumsTemplateData[i].emptyEditExpertPost = true;
      this.AllForumsTemplateData[i].characterEditExpertExceedError = false;
      return;
    } else if (editorTextOnly.trim().length > this.ckEditorWordsLimit) {
      this.AllForumsTemplateData[i].characterEditExpertExceedError = true;
      this.AllForumsTemplateData[i].emptyEditExpertPost = false;
      return;
    }
    this.AllForumsTemplateData[i].editSingleExpertPost = false;
    let checkboxes = <HTMLInputElement>document.getElementById("tag_" + postId);
    let answerTags = [];
    if (checkboxes.checked) {
      answerTags.push(parseInt(checkboxes.value));
    }
    //console.log(answerTags);
    this.editForumPopst(postId, followUpCKEditorquery, "", answerTags);
  }

  editFollowUpExpertReplyPost(postId, followUpCKEditorquery, i, j) {
    if (!this.AllForumsTemplateData[i].forumPostsVO[j].editSingleExpertPost) {
      return;
    }
    followUpCKEditorquery = (followUpCKEditorquery || '').replace(EMOJI_REGEX,'');
    var editorTextOnly = this.stripHTMLTags(followUpCKEditorquery);
    if (editorTextOnly.trim() == "") {
      this.AllForumsTemplateData[i].forumPostsVO[j].emptyEditExpertPost = true;
      this.AllForumsTemplateData[i].forumPostsVO[
        j
      ].characterEditExpertExceedError = false;
      return;
    } else if (editorTextOnly.trim().length > this.ckEditorWordsLimit) {
      this.AllForumsTemplateData[i].forumPostsVO[
        j
      ].characterEditExpertExceedError = true;
      this.AllForumsTemplateData[i].forumPostsVO[j].emptyEditExpertPost = false;
      return;
    }
    this.AllForumsTemplateData[i].forumPostsVO[j].editSingleExpertPost = false;
    this.editForumPopst(postId, followUpCKEditorquery, "", []);
  }
  editMainStudentQueryPost(postId, postSubject, followUpCKEditorquery, i) {
    if (!this.AllForumsTemplateData[i].editSingleStudentPost) {
      return;
    }
    followUpCKEditorquery =(followUpCKEditorquery || '').replace(EMOJI_REGEX,'')
    var editorTextOnly = this.stripHTMLTags(followUpCKEditorquery);
    let postHeading = this.stripHTMLTags(postSubject);
    if (editorTextOnly.trim() == "") {
      this.AllForumsTemplateData[i].emptyEditStudentPost = true;
      this.AllForumsTemplateData[i].characterEditStudentExceedError = false;
      this.AllForumsTemplateData[i].editEmptyPostSubject = false;
      this.AllForumsTemplateData[i].editCharacterExceedSubjectError = false;
      return;
    } else if (editorTextOnly.trim().length > this.ckEditorWordsLimit) {
      this.AllForumsTemplateData[i].characterEditStudentExceedError = true;
      this.AllForumsTemplateData[i].emptyEditStudentPost = false;
      this.AllForumsTemplateData[i].editEmptyPostSubject = false;
      this.AllForumsTemplateData[i].editCharacterExceedSubjectError = false;
      return;
    } else if (postHeading.trim() == "") {
      this.AllForumsTemplateData[i].editEmptyPostSubject = true;
      this.AllForumsTemplateData[i].characterEditStudentExceedError = false;
      this.AllForumsTemplateData[i].emptyEditStudentPost = false;
      this.AllForumsTemplateData[i].editCharacterExceedSubjectError = false;
      return;
    } else if (postHeading.trim().length > this.ckEditorHeadingLimit) {
      this.AllForumsTemplateData[i].editCharacterExceedSubjectError = true;
      this.AllForumsTemplateData[i].characterEditStudentExceedError = false;
      this.AllForumsTemplateData[i].emptyEditStudentPost = false;
      this.AllForumsTemplateData[i].editEmptyPostSubject = false;
      return;
    }
    this.AllForumsTemplateData[i].editSingleStudentPost = false;
    var answerTags = [];
    if (this.AllForumsTemplateData[i]["important"]) {
      answerTags.push(7);
    }
    this.editForumPopst(postId, followUpCKEditorquery, postSubject, answerTags);
  }

  editFollowUpStudentQueryPost(postId, followUpCKEditorquery, i, j) {
    if (!this.AllForumsTemplateData[i].forumPostsVO[j].editSingleStudentPost) {
      return;
    }
    followUpCKEditorquery = (followUpCKEditorquery || '').replace(EMOJI_REGEX,'');
    var editorTextOnly = this.stripHTMLTags(followUpCKEditorquery);
    if (editorTextOnly.trim() == "") {
      this.AllForumsTemplateData[i].forumPostsVO[j].emptyEditStudentPost = true;
      this.AllForumsTemplateData[i].forumPostsVO[
        j
      ].characterEditStudentExceedError = false;
      return;
    } else if (editorTextOnly.trim().length > this.ckEditorWordsLimit) {
      this.AllForumsTemplateData[i].forumPostsVO[
        j
      ].characterEditStudentExceedError = true;
      this.AllForumsTemplateData[i].forumPostsVO[j].emptyEditStudentPost =
        false;
      return;
    }
    this.AllForumsTemplateData[i].forumPostsVO[j].editSingleStudentPost = false;
    this.editForumPopst(postId, followUpCKEditorquery, "", []);
  }

  editForumPopst(postId, followUpCKEditorquery, postNewSubject, tags) {
    let postData = {
      postSubject: postNewSubject,
      postText: followUpCKEditorquery,
      forumPostId: postId,
      tagIdSet: tags,
    };
    let headers = new HttpHeaders();
    this.httpClientService
      .put(AppSettings.restApiUrl + "/api/forum/post/edit", postData, headers)
      .subscribe((data) => {
        this.getForumsData();
        this.scrollToEditedFroumPost(postId);
        this.updateResult();
      });
  }

  scrollToEditedFroumPost(postId) {
    var forumsLocation = document.getElementById(postId).offsetTop - 15;
    window.scroll({
      top: forumsLocation,
      left: 0,
      behavior: "smooth",
    });
  }

  deletePostExpertConfirmation(itmeId) {
    this.deletePostConfirmation = true;
    document.body.classList.add("coursePopIn");
    this.deletePostId = itmeId;
  }
  deletePostExpert() {
    if (!this.isDeleteButtonActive) {
      this.isDeleteButtonActive = true;
      document.body.classList.remove("coursePopIn");
      let headers = new HttpHeaders();
      this.httpClientService
        .put(
          AppSettings.restApiUrl +
            "/api/forum/post/delete/" +
            this.deletePostId,
          null,
          headers
        )
        .subscribe((data) => {
          this.getForumsData();
          this.deletePostConfirmation = false;
          this.isDeleteButtonActive = false;
          document.body.classList.remove("coursePopIn");
        });
    }
  }
  closeConfirmationPopUp() {
    this.deletePostConfirmation = false;
    this.isDeleteButtonActive = false;
    document.body.classList.remove("coursePopIn");
  }

  scrollToTop() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }
  scrollToCKEditorNewQuery() {
    //var scrollPos = document.getElementById('newQueryPostBtn');
    //setTimeout(function(){window.scrollBy(0, 100);},500);
    /*var timerID = setInterval(function()
    {

        if( scrollableWindow.scrollTop <= 1)
        {
            clearInterval(timerID);
            return;
        }
          scrollableWindow.scrollTop  = scrollableWindow.scrollTop - 15;
    }, 5);*/
  }
  blurFocus() {
    (<HTMLElement>document.activeElement).blur();
  }
    /**
   * update math expression
   */
    updateResult () {
      const mathContainer1 = this.displayForumsThreadAfter.nativeElement.innerHTML
      // Rerender the entire resultDiv
      MathJax.Hub.Queue(["Typeset",MathJax.Hub,mathContainer1]);
    }
  
}
